var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kpi cx-card-height"},[_c('head-text',{attrs:{"kpi":_vm.Primary,"isSmall":_vm.isSmall,"fallbackText":_vm.fallbackText}}),_vm._v(" "),_c('item',{attrs:{"thresholdData":_vm.thresholdData,"round":true,"isSmall":_vm.isSmall,"kpi":_vm.Primary}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }